export interface RefundMeta {
	limit: number;
	next: string | null;
	offset: number;
	previous: string | null;
	total_count: number;
}

export interface RefundPaymentDetail {
	payment_id: number;
	receipt_no: string;
	payment_date: string;
	payment_mode: string;
	payment_mode_id: number;
	paid_amount: number;
	currency: string;
	number: string | null;
	cheque_date: string | null;
	bank: string | null;
	remarks: string | null;
}

export interface RefundListItem {
	refund_id: number;
	refund_date: string;
	status: string;
	refund_against: string;
	patient_id: number;
	package_name: string | null;
	patient_name: string;
	age: number;
	gender: string;
	receipt_no: string | null;
	bill_advance_number: string | null;
	total_amount: string;
	concession_amount: string | null;
	total_tax_amount?: string | null;
	net_amount: string | null;
	requested_amount: string | null;
	refunded_amount: number;
	available_balance: number;
	refund_reason: string | null;
	refund_reason_id: number | null;
	can_print: boolean;
	date: string;
	patient_mrn_no: string;
	invoice_items?: RefundInvoiceItem[];
	payment_details?: RefundPaymentDetail[];
	clinic?: string | null;
	clinic_id?: number | null;
	patient_package_id?: number | null;
	remark?: string | null;
}

export interface RefundListResponse {
	meta: RefundMeta;
	objects: RefundListItem[];
}

export interface RefundInvoiceItem {
	invoice_number: string;
	date: string; 
	refund_number: string;
	invoice_item_code: string;
	service_name: string;
	package_name: string | null;
	package_id?: number | null;
	provider_name: string;
	bill_type: string;
	charges: string; 
	concession_amount: string;
	net_amount: string;
	refund_reason?: string | null;
	refund_reason_id?: number | null;
}

export interface RefundHistoryUser {
	id: number;
	username: string;
	full_name: string;
}

export interface RefundHistoryItem {
	history_id: number;
	history_date: string;
	history_change_reason: string | null;
	history_type: string;
	history_user: RefundHistoryUser;
	id: number;
	date: string;
	refund_type: string;
	receipt_number: string | null;
	bill_advance_number: string | null;
	total_amount: string;
	concession_amount: string;
	net_amount: string;
	requested_amount: string;
	refund_amount: string;
	refund_reason: string | null;
	refund_reason_id?: number | null;
	status: string;
	clinic?: string | null;
	clinic_id?: number | null;
}

export interface RefundHistoryListResponse {
	meta: RefundMeta;
	objects: RefundHistoryItem[];
}

export interface InvoiceServiceItem {
	id?: number;
	invoice_item_id: number;
	invoice_number: string;
	date: string;
	refund_number: string;
	invoice_item_code: string;
	service_name: string;
	package_name: string | null;
	package_id: number | null;
	provider_name: string;
	bill_type: string;
	charges: string;
	concession_amount: string;
	net_amount: string;
	refund_status?: boolean;
	refund_reason?: string | null;
	refund_reason_id?: number | null;
}

export interface InvoiceServices {
	id: number;
	invoice_items: InvoiceServiceItem[];
	patient_name: string;
	patient_mrn: string;
	invoice_bill_number: string;
	advance_number: string;
	advance_amount: number | null;
	package_name: string;
	package_amount: number | null;
	consumed_amount: number | null;
	remaining_amount: number | null;
	refund_against: string;
	invoice_already_refunded: number;
	invoice_remaining_refundable: number;
	advance_available_balance: number | null;
	created_on: string;
	updated_on: string;
	deleted_on: string | null;
	deleted_reason: string | null;
	date: string;
	refund_type: string;
	status: string;
	receipt_number: string;
	total_amount: string;
	concession_amount: string;
	net_amount: string;
	requested_amount: string;
	refund_amount: string;
	refund_reason: string;
	refund_reason_id?: number | null;
	tenant: number;
	patient: number;
	invoice: number;
	advance_transaction: number | null;
	clinic?: string | null;
	clinic_id?: number | null;
}

export interface InvoiceRefundRow {
  id: number;
  date: string;
  totalAmount: string;
  receiptNo: string;
  bill_advance_number: string | null;
  against: string;
  packageName: string | null;
  concession_amount: number;
  net_amount: number;
  requested_amount: number;
  remainingAmount?: number;
}
export interface PaymentDetailPayload {
	payment_mode_id: number;
	paid_amount: string;
	currency: string;
	number: string | null;
	date: string;
	bank_id: number | null;
	account_name: string | null;
	branch_name: string | null;
	ifsc_code: string | null;
	remarks: string | null;
	cheque_number: string | null;
	cheque_date: string | null;
	upi_provider_id?: number | null;
}

export interface RefundPaymentPayload {
  patient_id: number;
  clinic_id: number;
  payment_against_type: 'REFUND';
  refund_type: 'ADVANCE', 
  refund_id: number;
  refund_amount: string;  
  remarks: string;
  payment_details: PaymentDetailPayload[];
}

export interface InvoiceRefundPaymentPayload {
	payment_against_type: 'REFUND';
	refund_id: number;
	refund_type: 'INVOICE';
	invoice_items: number[];
	refund_amount: string;
	clinic_id: number;
	remarks: string;
	payment_details: PaymentDetailPayload[];
}

export interface RefundStats {
	refund_requested: number;
	refunded: number;
	total_refunds: number;
	pharmacy_return: number;
}

export function getRefundListsURL(): string {
  return 'refunds/';
}

export function getPackageConfigConfigURL(): string {
  return 'billing/billing-config-options/?module=refund';
}

export function getRefundStats(): string {
  return 'refunds/refund-stats/';
}
